import {MathJax, MathJaxContext} from "better-react-mathjax";
import {isNullOrUndefined} from "../../../services/Validator";
import DetailedCourseExampleCardHeader from "../courses/DetailedCourseExampleCardHeader";
import SystemCardHeaderDivider from "../../dividers/SystemCardHeaderDivider";

export default function GlossaryDetailedTermExample({example}) {
    // Used in

    // BUILD
    if (isNullOrUndefined(example))
        return null
    return (
        <div className={"bg-backgroundLight5 w-full flex-col shadow-[inset_0px_1px_2px_rgba(82,96,120,1)] rounded-[16px] mt-[16px] pb-[12px]"}>
            {/** HEADER */}
            <DetailedCourseExampleCardHeader headerTitle={`Exemple`} />
            <SystemCardHeaderDivider />
            {/** CONTENT */}
            <div className={"w-full flex px-[12px] mt-[8px]"}>
                <MathJaxContext>
                    <MathJax inline dynamic>
                    <span className="whitespace-pre-line font-semibold text-[16px] text-greyLight11">
                        {example}
                    </span>
                    </MathJax>
                </MathJaxContext>
            </div>
        </div>
    );
}